// @flow

import { isEqual } from "lodash";
import * as React from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import NProgress from "nprogress";
import API from "../api/user";
import queryString from "query-string";
import Config from "../constants/Config";
import actions from "../actions/index.js";
import Pagination from "../components/molecules/Pagination";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import TicketProfileBody from "../components/organisms/TicketProfileBody";
import NavTabs from "../components/molecules/NavTabs";
import CustomMeta from "../components/atoms/CustomMeta.js";

const ProfileTickets = (): React.Node => {
    const POSTS_PER_PAGE = 12;
    const PAGINATION_WIDTH = 2;

    const dispatch = useDispatch();
    const history = useHistory();
    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];
    const [tickets, setTickets] = React.useState([]);
    const [headers, setHeaders] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true);
    const [params, setParams] = React.useState({ page_num: 1 });

    const queryParamProps = queryString.parse(history.location.search);
    const activePage = Number(queryParamProps.page_num) || 1;
    const totalPages = parseInt(headers["x-wp-totalpages"]) || 1;
    // const totalItems = parseInt(headers["x-wp-total"]) || 0;

    // set query params in state on change of any params
    if (!isEqual(queryParamProps, params)) {
        setParams(queryParamProps);
    }

    const tabs = [
        {
            to: Config.routes.incomingTickets,
            title: "Upcoming",
            value: "upcoming",
        },
        {
            to: Config.routes.pastTickets,
            title: "Past",
            value: "past",
        },
    ];

    React.useEffect((): any => {
        let cancel = false;
        NProgress.start();
        if (history.location.pathname.startsWith("/my-account/tickets")) {
            setTickets([]);
            setIsLoading(true);
            API.userGetMyTickets({
                page: params.page_num,
                perPage: POSTS_PER_PAGE,
                type: tabs.filter(
                    tab => tab.to === history.location.pathname
                )[0].value,
            })
                .then(
                    ({
                        data,
                        headers,
                    }: {
                        data: Array<any>,
                        headers: Object,
                    }) => {
                        if (!cancel) {
                            setTickets(data);
                            setHeaders(headers);
                        }
                    }
                )
                .finally(() => {
                    // setInitialLoad(false);
                    setIsLoading(false);
                    NProgress.done();
                    scrollToTop();
                });
        }
    }, [params]); // eslint-disable-line

    const scrollToTop = () => {
        // if (containerRef.current) {
        //     scrollToEl(containerRef.current);
        // }

        window.scrollTo({
            top: 0,
            left: 0,
            // behavior: "smooth",
        });
    };

    return (
        <React.Fragment>
            <CustomMeta title="Tickets" />

            <HeroProfilePage heading="Tickets" breadcrumbs={breadcrumbs} />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <NavTabs
                            tabs={tabs}
                            className="tickets-profile"
                            cta={{
                                url: "/events",
                                title: "Browse all events",
                            }}
                        />
                    </div>
                </div>
            </div>

            <Switch>
                <Route
                    exact
                    path={Config.routes.incomingTickets}
                    render={() => {
                        return (
                            <TicketProfileBody
                                tickets={tickets}
                                type="upcoming"
                                isLoading={isLoading}
                            />
                        );
                    }}
                />

                <Route
                    exact
                    path={Config.routes.pastTickets}
                    render={() => {
                        return (
                            <TicketProfileBody
                                tickets={tickets}
                                type="past"
                                isLoading={isLoading}
                            />
                        );
                    }}
                />
            </Switch>

            {totalPages > 1 ? (
                <div className="listing__pagination">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-offset-2 col-md-8">
                                <Pagination
                                    ellipsisWidth={PAGINATION_WIDTH}
                                    pages={totalPages}
                                    activePage={activePage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

ProfileTickets.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([
        store.dispatch(actions.fetchPage(location.pathname, location.search)),
    ]);
};

export default ProfileTickets;
